export const PathsUrls = {
  home: '/',
  about: '/about',
  blog:'/blog',
  ourTeam: '/team',
  contactUs: '/contact'
};
